import store from "@/store/index.ts";
import router from "@/router.ts";
import { ICoupon } from "@/i/coupon.ts";

interface ICouponFromStore {
  name: string;
  data: ICoupon;
  redirect: string;
}

export default () => {
  const coupon = localStorage.getItem("opened-coupon");
  if (coupon) {
    const couponObj: ICouponFromStore = JSON.parse(coupon);
    setTimeout(() => {
      router.push({ path: couponObj.redirect });
    });
    store.dispatch("app/togglePopupAction", {
      data: couponObj.data,
      name: couponObj.name
    });
    localStorage.removeItem("opened-coupon");
  }
};
